import styled from 'styled-components/macro'
import { Alert } from '@mui/material'
import checkCircle from '../../../assets/icons/check-circle-solid 1.png'
import exclamationCircle from '../../../assets/icons/exclamation-circle-solid 1.png'
import { Snackbar } from '@mui/material'

export const StyledSnackbar = styled(Snackbar)<{
  severity: 'error' | 'success'
}>`
  display: flex;
  .css-1pxa9xg-MuiAlert-message {
    font-family: 'InterRegularHe';
    font-size: 16px;
    font-weight: 500;
    color: ${({ severity }) =>
      severity === 'error'
        ? '#AF233A'
        : severity === 'success'
          ? '#0D6832'
          : 'inherit'};
  }
`

export const CustomAlert = styled(Alert)<{ severity: 'error' | 'success' }>`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${({ severity }) =>
    severity === 'error'
      ? '#F9E1E5;'
      : severity === 'success'
        ? '#DCFCE7'
        : 'inherit'};

  border: 1px solid
    ${({ severity }) =>
      severity === 'error'
        ? '#AF233A'
        : severity === 'success'
          ? '#0D6832'
          : 'transparent'};
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

  .MuiAlert-icon {
    background-image: ${({ severity }) =>
      severity === 'success' ? checkCircle : exclamationCircle};
  }
`
